import { PartnerLinkListAdapter } from './partner-link-list.adapter';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { GGPartnerLink } from '../../model/product.model';

export interface GGProductRetailersListWsDTO {
  strategy: string;
  retailer: GGPartnerLink[];
}

@Injectable({
  providedIn: 'root',
})
export class OccPartnerLinkListAdapter implements PartnerLinkListAdapter {
  constructor(
    private http: HttpClient,
    private occEndpoints: OccEndpointsService
  ) {}

  fetchPartnerLinkList(actionType: string, productCode: string): Observable<GGProductRetailersListWsDTO> {
    let params = new HttpParams();
    params = params.append('productCode', productCode!);
    params = params.append('actionType', actionType!);

    const url = this.occEndpoints.buildUrl('partnerLinkList');

    return this.http.post<GGProductRetailersListWsDTO>(url, params);
  }
}
